var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply-page"},[_c('van-cell-group',[(_vm.isLoan)?_c('van-cell',{attrs:{"is-link":_vm.isLoan,"to":_vm.IsApplied?'./apply-detail-locate':'./apply-locate'}},[_c('div',{staticClass:"title-box",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"custom-text"},[_vm._v("正畸定位器工具包")])])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740684a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/member/apply.vue
// module id = null
// module chunks = 